<template>
  <div class="report-filter" :key="updateKey">
    <!-- Toggler -->
    <div class="toggler">
      <div class="left">
        <input :checked="isFilterEnabled"
               @change="toggleFilter(filterKey)"
               type="checkbox">
      </div>
      <div class="right">
        <a href="#" @click.prevent="toggleFilter(filterKey)"><b>Caused by ITG Error</b></a>
      </div>
    </div>
    <!-- / Toggler -->

    <!-- Options -->
    <div class="options" v-if="isFilterEnabled">
      <v-select :options="causedByItgErrorOptions" label="label"
                :reduce="option => option.value"
                @option:selected="incrementUpdateKey"
                @option:deselected="incrementUpdateKey"
                :value="params['caused_by_itg_error']"
                @input="setCausedByItgErrorFilter">
      </v-select>
    </div>
    <!-- / Options -->
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Tickets from "../../../../../mixins/Tickets";

export default {
  name: "CausedByItgErrorFilter",
  mixins: [Tickets],
  data() {
    return {
      filterKey: 'caused_by_itg_error',
      updateKey: 1,
      causedByItgErrorOptions: [
        {
          label: 'Yes',
          value: '1'
        },
        {
          label: 'No',
          value: '0'
        }
      ]
    }
  },
  methods: {
    ...mapActions('reportEditor', {
      toggleFilter: 'toggleFilter',
      setCausedByItgErrorFilter: 'setCausedByItgErrorFilter'
    }),

    incrementUpdateKey() {
      this.updateKey += 1;
    }
  },
  computed: {
    ...mapGetters('reportEditor', {
      filtersEnabled: 'filtersEnabled',
      params: 'params'
    }),

    isFilterEnabled() {
      return this.filtersEnabled.includes(this.filterKey);
    }
  }
}
</script>

<style lang="scss" scoped>
.report-filter {
  background: #fff;
  border-radius: 5px;
  padding: 13px 15px;
  margin-bottom: 15px;

  .toggler {
    display: flex;
    flex-direction: row;
    align-items: center;

    .left {
      flex-shrink: 1;
      padding-top: 4px;
      padding-right: 15px;
    }

    .right {
      flex: 1;
      font-weight: 600;
      color: #2c5cc5;
    }
  }

  .options {
    margin-top: 10px;
  }
}
</style>